<template>
  <div class="form-container">
    <img src="../assets/head.png" alt="示例图片" style="max-width: 510px; width: 100%; margin: 0 auto;" />
    <!-- 提交成功后的提示信息 -->
    <div v-if="status === 'success'" class="submission-info" >
      <p class="info-text">您的信息已提交成功/Your information has been successfully submitted.</p>
      <ul class="info-list">
        <!-- <li><strong>姓名/Name：</strong>123</li>
        <li><strong>性别/Gender：</strong>123</li>
        <li><strong>公司名称/Company：</strong>123</li>
        <li><strong>部门&职位/Department & Position：</strong>123</li>
        <li><strong>邮箱/Email：</strong>123</li>
        <li><strong>电话/Phone：</strong>123</li>
        <li><strong>感兴趣的产品/Product of Interest：</strong>123</li> -->

        <!-- <li><strong>姓名/Name：</strong>{{ submittedData.name }}</li>
        <li><strong>性别/Gender：</strong>{{ submittedData.gender }}</li>
        <li><strong>公司名称/Company：</strong>{{ submittedData.company }}</li>
        <li><strong>部门&职位/Department & Position：</strong>{{ submittedData.departmentPosition }}</li>
        <li><strong>邮箱/E-mail：</strong>{{ submittedData.email }}</li>
        <li><strong>电话/Phone：</strong>{{ submittedData.phone }}</li>
        <li><strong>感兴趣的产品/Product of Interest：</strong>{{ submittedData.productOfInterest }}</li> -->

        <li><strong>姓名/Name：</strong>{{ submittedData.name }}</li>
        <li><strong>性别/Gender：</strong>{{ submittedData.gender }}</li>
        <li><strong>公司名称/Company：</strong>{{ submittedData.company }}</li>
        <li><strong>部门&职位/Department & Position：</strong>{{ submittedData.departmentPosition }}</li>
        <li><strong>邮箱/E-mail：</strong>{{ submittedData.email }}</li>
        <li><strong>电话/Phone：</strong>{{ submittedData.phone }}</li>
        <li><strong>留言/Your message：</strong>{{ submittedData.productOfInterest }}</li>
      </ul>
      <el-button type="primary" @click="editSubmittedData" class="full-width">修改信息/Edit</el-button>
      <div style="height:400px"></div>
    </div>

    <!-- 表单 -->
    <el-form
      :model="formData"
      :rules="rules"
      hide-required-asterisk
      ref="formRef"
      label-position="top"
      class="responsive-form"
      v-if="status == 'submit'"
    >
      <!-- 姓名输入框 -->
      <el-form-item label="姓名/Name" prop="name" class="custom-label" style="margin-top:20px" > 
      
        <el-input v-model="formData.name" ></el-input>
      </el-form-item>

      <!-- 性别选择框 -->
      <el-form-item label="性别/Gender" prop="gender" class="custom-label">
        <el-select v-model="formData.gender" placeholder="">
          <el-option v-for="option in genderOptions" :key="option" :label="option" :value="option"></el-option>
        </el-select>
      </el-form-item>

      <!-- 公司输入框 -->
      <el-form-item label="公司名称/Company" prop="company" class="custom-label">
        <el-input v-model="formData.company" placeholder=""></el-input>
      </el-form-item>

      <!-- 部门&职位输入框 -->
      <el-form-item label="部门&职位/Department&Position" prop="departmentPosition" class="custom-label">
        <el-input v-model="formData.departmentPosition" placeholder="" class="no-border"></el-input>
      </el-form-item>

      <!-- 邮箱输入框 -->
      <el-form-item label="邮箱/E-mail" prop="email" class="custom-label">
        <el-input v-model="formData.email" placeholder=""></el-input>
      </el-form-item>

      <!-- 电话输入框 -->
      <el-form-item label="电话/Phone" prop="phone" class="custom-label">
        <el-input v-model="formData.phone" placeholder=""></el-input>
      </el-form-item>

      <!-- 感兴趣的产品输入框 -->
      <el-form-item label="留言/Your message" prop="productOfInterest" class="custom-label">
        <el-input
          v-model="formData.productOfInterest"
          type="textarea"
          :rows="3"
          placeholder=""
        ></el-input>
      </el-form-item>

      <!-- 隐私政策复选框 -->
      <el-form-item class="privacy-policy" >
        <span class="privacy-text">
             <el-checkbox v-model="isPrivacyChecked" class="privacy-checkbox"/>
          隐私提示: 点击“提交”按钮则默认您同意
          <a href="#" @click.prevent="showModal = true">《奥特维隐私政策》</a>
           <br />
          Privacy Notice: By submitting this form, you acknowledge that you have read and agree to the 
          <a href="#" @click.prevent="showModalen = true">《Autowell Privacy Policy》</a>
        </span>
      </el-form-item>

      <!-- 提交按钮 -->
      <el-form-item style="margin-top: 10px;">
        <el-button type="primary" @click="validateBeforeSubmit" :disabled="!isPrivacyChecked" class="full-width">
          提交/Submit
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 备案信息 -->
    <a  class="link el-mt-lg text-center block">
      <img src="/icons/jh.png" alt="" /> 苏ICP备12031717号-7
    </a>

    <!-- 隐私政策对话框 -->
    
<el-dialog 
  v-model="showModal" 
 style=" max-width: 500px; width:100%;  "
>
<ChildComponent v-if="showModal" @close="showModal = false" />
</el-dialog>


<el-dialog 
  v-model="showModalen" 
 style=" max-width: 500px; width:100%;  "
>
<ChildENComponent v-if="showModalen" @close="showModalen = false" />
</el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ChildComponent from './ChildComponent.vue'; // 引入子组件
import ChildENComponent from './ChildENComponent.vue'; // 引入子组件src\components\ChildENComponent.vue
export default {
  components: { ChildComponent,ChildENComponent },
  name: "SubmitForm",
  data() {
    return {
      formData: {
        name: "",
        gender: "",
        company: "",
        departmentPosition: "",
        email: "",
        phone: "",
        productOfInterest: ""
      },
      editflag: false,
      status: "submit",
      submittedData: null,
      genderOptions: ["男 (Male)", "女 (Female)"],
      isPrivacyChecked: false,
      showModal: false,
      showModalen: false,
      url: "https://subscribe.wxautowell.com:15001",
      rules: {
        name: [{ required: true, message: "请输入您的姓名/Please enter Name", trigger: "blur" }],
        company: [{ required: true, message: "请输入您的公司名称/Please enter Company", trigger: "blur" }],
        departmentPosition: [
          { required: true, message: "请输入您的部门和职位/Please enter Department&Position", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入有效的邮箱/Please enter Email", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确/The email format is incorrect", trigger: "blur" }
        ],
        productOfInterest: [
          { required: true, message: "请输入您的留言/Please enter Your message", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    validateBeforeSubmit() {
      if (!this.isPrivacyChecked) {
        this.$message.error("请先同意隐私政策！");
        return;
      }

      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.editflag) {
            this.editFormData();
          } else {
            this.submitFormData();
          }
        } else {
          this.$message.error("请检查表单是否填写完整！");
        }
      });
    },
    async submitFormData() {
      try {
        const response = await axios.post(
          this.url + "/complaints-api/biz/customers/insertcus",
          this.formData
        );

        if (response.status === 200) {
          this.$message.success("提交成功/Submit successfully");
          this.saveToCache(this.formData);
          this.submittedData = { ...this.formData };
          this.resetForm();
          this.status = "success";
        } else {
          this.$message.error("提交失败，请稍后重试！");
        }
      } catch (error) {
        this.$message.error("提交表单时发生错误: " + error);
      }
    },
    async editFormData() {
      try {
        const response = await axios.post(
          this.url + "/complaints-api/biz/customers/editcus",
          this.formData
        );

        if (response.status === 200) {
          this.$message.success("修改成功/Edit successfully");
          this.saveToCache(this.formData);
          this.submittedData = { ...this.formData };
          this.resetForm();
          this.status = "success";
        } else {
          this.$message.error("修改失败，请稍后重试！");
        }
      } catch (error) {
        this.$message.error("修改表单时发生错误: " + error);
      }
    },
    saveToCache(data) {
      localStorage.setItem("submittedData", JSON.stringify(data));
    },
    loadFromCache() {
      const cachedData = localStorage.getItem("submittedData");
      if (cachedData) {
        this.submittedData = JSON.parse(cachedData);
      }
    },
    resetForm() {
      this.formData = {
        name: "",
        gender: "",
        company: "",
        departmentPosition: "",
        email: "",
        phone: "",
        productOfInterest: ""
      };
    },
    editSubmittedData() {
      this.formData = { ...this.submittedData };
      this.status = "submit";
      this.editflag = true;
      this.submittedData = null;
    }
  },
  mounted() {
    this.loadFromCache();
  }
};
</script>

<style scoped>
/* 居中容器 */
.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh; /* 占满整个视口高度 */
  padding: 20px;
  box-sizing: border-box;
}

/* 表单样式 */
.responsive-form {
  width: 100%;
  max-width: 500px; /* 控制表单的最大宽度 */
}

/* 自定义 Label 样式 */


/* 输入框样式 */
.el-input,
.el-textarea {
  width: 100%;
}

/* 强制移除默认的 padding 和 margin */
.el-form-item {
  margin-bottom: 20px;
  padding-left: 0 !important;
}

/* 提交按钮样式 */
.full-width {
  width: 100%;
}

/* 文本居中 */
.text-center {
  text-align: center;
}

::v-deep(.custom-label) {
display: block !important; /* 强制垂直布局 */
  
  /* 标签样式 */
  .el-form-item__label {
    display: block !important;
    width: 100% !important;
    text-align: left !important;
    float: none !important; /* 清除 element 默认浮动 */
    padding: 0 0 1px 0 !important; /* 添加下间距 */
    line-height: 0.1; /* 调整行高 */
  }

  /* 内容区域样式 */
  .el-form-item__content {
    display: block !important;
    width: 100%;
    margin-left: 0 !important; /* 清除默认左边距 */
  }

  /* 输入框宽度控制 */
  .el-input {
    width: 100%;
  }
}
/* 表单项容器控制最大宽度 */
::v-deep(.privacy-policy) {
  max-width: 500px;
  width: auto !important;  /* 取消Element默认固定宽度 */
}


/* 复选框内容样式 */
::v-deep(.privacy-checkbox) {
  .el-checkbox__label {
    white-space: normal !important;  /* 允许自动换行 */
    word-wrap: break-word;           /* 长单词强制换行 */
    line-height: 0.1;                /* 优化中英文混排 */
    text-align: left;             /* 两端对齐 */
    max-width: 100%;                 /* 继承父级最大宽度 */
  }
  
  /* 链接样式 */
  a {
    display: inline-block;
    word-break: break-word;
    hyphens: auto;        /* 英文单词自动加连字符 */
    color: #409EFF;
    text-decoration: underline;
  }
}

::v-deep(.privacy-policy) {
  display: flex !important;
  justify-content: center !important;
  margin: 0 auto !important;
  text-align: left;  /* 文本左对齐 */
  
}
.privacy-text{
  line-height: 1.5;
}

::v-deep(.privacy-modal) {
  /* 固定弹窗高度 */
  --modal-height: 70vh;
  
  display: flex;
  flex-direction: column;
  max-height: var(--modal-height);
  overflow: hidden; /* 隐藏外层滚动 */
  border-radius: 8px;
  
 
}



.modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 标题栏固定 */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  position: sticky;
  top: 0;
  z-index: 1;
}

.title {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.close-btn {
  padding: 8px;
  font-size: 16px;
}

/* 可滚动内容区域 */
.scroll-content {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  /* 优化滚动体验 */
  overscroll-behavior: contain; /* 防止父级滚动 */
  scroll-behavior: smooth;
}

/* 内容样式优化 */
h5 {
  color: #606266;
  margin: 20px 0 12px;
}

.content-list,
.definition-list,
.contact-list {
  padding-left: 24px;
  line-height: 1.6;
  margin: 12px 0;
}

/* 滚动条样式美化 */
.scroll-content::-webkit-scrollbar {
  width: 6px;
}

.scroll-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.scroll-content::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.scroll-content::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

::v-deep .el-form-item.is-required .el-form-item__label::after {
  content: '*';
  color: #f56c6c;
  margin-left: 4px;
}

.privacy-modal ::v-deep ol,
.privacy-modal ::v-deep ul {
  padding-left: 0 !important;  /* 消除默认左内边距 ‌:ml-citation{ref="8" data="citationList"} */
  margin-left: 1.5em;          /* 控制编号缩进 ‌:ml-citation{ref="8" data="citationList"} */
}

.privacy-modal ::v-deep li {
  text-align: left !important; /* 强制文本左对齐 ‌:ml-citation{ref="6,8" data="citationList"} */
  margin-left: 0;
  list-style-position: outside; /* 编号显示在内容区外侧 ‌:ml-citation{ref="6" data="citationList"} */
  text-indent: -1em;           /* 多行文本对齐修正 ‌:ml-citation{ref="8" data="citationList"} */
  padding-left: 1em;           /* 内容与编号间距 ‌:ml-citation{ref="2" data="citationList"} */
}
::v-deep .submission-info{
  text-align: left;
}
</style>